"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMutations = sendMutations;
const GraphQLRequest = __importStar(require("@genesys/graphql-request"));
const GraphQLEntityCache = __importStar(require("gql-cache"));
const GraphQL = __importStar(require("graphql"));
const GraphQLAddRemoveFields = __importStar(require("graphql-add-remove-fields"));
const server_patches_1 = require("./server-patches");
const types_1 = require("./types");
async function sendMutations(mutationsQueue, objectToId, includeServerLog, endpoint, authorization) {
    const sentMutationResults = [];
    for (const m of mutationsQueue.queuedMutations) {
        const sentMutationResult = await sendMutation(m, objectToId, includeServerLog, endpoint, authorization);
        sentMutationResults.push(sentMutationResult);
    }
    return sentMutationResults;
}
async function sendMutation(queuedMutation, objectToId, includeServerLog, endpoint, authorization) {
    const mutationWithRequiredFields = GraphQLAddRemoveFields.addFields(queuedMutation.document, ["__typename"]);
    const response = await GraphQLRequest.request(GraphQL.print(mutationWithRequiredFields), queuedMutation.variables, includeServerLog, endpoint, authorization);
    const queryWithoutCachePatches = GraphQLAddRemoveFields.removeFields(mutationWithRequiredFields, [types_1.cachePatchesKey]);
    const cachePatches = (0, server_patches_1.getCachePatchesFromResponse)(response, objectToId);
    const normalizedEntities = GraphQLEntityCache.normalize(queryWithoutCachePatches, queuedMutation.variables, {
        data: response
    }, objectToId);
    return {
        mutation: queuedMutation,
        newEntities: normalizedEntities,
        cachePatches: cachePatches,
        response,
        error: undefined
    };
}
//# sourceMappingURL=send-mutations.js.map